
import React from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import SEOHead from '@/components/common/SEOHead';
import { SITE_URL } from '@/lib/constants/urls';
import {
  AboutHero,
  MissionSection,
  WorkflowSection,
  EUProcessingSection,
  TeamSection
} from '@/components/about';

const About = () => {
  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "About PaperVerse",
      "url": `${SITE_URL}/about`,
      "description": "PaperVerse is an AI co-author and peer-review platform for academic writing. Draft in LaTeX with PaperVerse Writer, cite real sources, and get structured AI reviews before journal reviewers do. Private drafts are processed in the European Union.",
      "isPartOf": { "@type": "WebSite", "name": "PaperVerse", "url": SITE_URL },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "PaperVerse",
      "legalName": "PaperVerse UG (haftungsbeschränkt)",
      "url": SITE_URL,
      "logo": `${SITE_URL}/logo.png`,
      "description": "PaperVerse connects AI-assisted academic writing, research, review, and revision while keeping researchers in control.",
      "foundingDate": "2023",
      "sameAs": [
        "https://linkedin.com/company/paperverse"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Home", "item": `${SITE_URL}/` },
        { "@type": "ListItem", "position": 2, "name": "About", "item": `${SITE_URL}/about` },
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <div className="flex min-h-screen flex-col">
        <SEOHead 
          title="About PaperVerse — AI Co-Author and Peer Review for Researchers"
          description="PaperVerse is an AI co-author for academic writing: draft in LaTeX, cite real sources, and get structured AI peer review before journal reviewers do. Private drafts, processed in the European Union."
          canonicalUrl={`${SITE_URL}/about`}
          keywords="about PaperVerse, AI academic writing assistant, AI LaTeX writer, AI peer review platform, research paper review, literature research, paper revision"
          structuredData={structuredData}
        />
        
        <Navbar />
        
        <AboutHero />
        <MissionSection />
        <WorkflowSection />
        <EUProcessingSection />
        <TeamSection />
        
        <Footer noMarginTop />
      </div>
    </div>
  );
};

export default About;
